export enum OsInBEEnum {
  MAC = 'mac',
  WINDOWS = 'windows',
  IOS = 'ios',
  ANDROID = 'android',
}
